import { render, staticRenderFns } from "./AppDropdown.vue?vue&type=template&id=72f5f770&lang=pug"
import script from "./AppDropdown.vue?vue&type=script&lang=js"
export * from "./AppDropdown.vue?vue&type=script&lang=js"
import style0 from "./AppDropdown.vue?vue&type=style&index=0&id=72f5f770&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports